import { render, staticRenderFns } from "./full-hotel-info-recycler-list.vue?vue&type=template&id=5b6ae886&"
import script from "./full-hotel-info-recycler-list.vue?vue&type=script&lang=ts&"
export * from "./full-hotel-info-recycler-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports